import { Component } from '@angular/core';

import { TextAreaWidget } from '../../base/textarea.widget';

@Component({
  selector: 'sf-textarea-widget',
  template: `<div class="widget form-group">
	<label [attr.for]="id" class="horizontal control-label">
		{{ schema.title }}
	</label>
    <span *ngIf="schema.description" class="formHelp">{{schema.description}}</span>
	<textarea [attr.readonly]="schema.readOnly" [name]="formProperty.name"
		class="text-widget textarea-widget form-control"
		[attr.placeholder]="schema.placeholder"
		[attr.maxLength]="schema.maxLength || null"
    [attr.minLength]="schema.minLength || null"
		[formControl]="formProperty"></textarea>
</div>`
})
export class TextAreaComponent extends TextAreaWidget {}
